export var InfectionLevel;
(function (InfectionLevel) {
    InfectionLevel[InfectionLevel["none"] = 0] = "none";
    InfectionLevel[InfectionLevel["light"] = 1] = "light";
    InfectionLevel[InfectionLevel["medium"] = 2] = "medium";
    InfectionLevel[InfectionLevel["severe"] = 3] = "severe";
})(InfectionLevel || (InfectionLevel = {}));
export var InfectionEvolutionStatus;
(function (InfectionEvolutionStatus) {
    InfectionEvolutionStatus[InfectionEvolutionStatus["current"] = 0] = "current";
    InfectionEvolutionStatus[InfectionEvolutionStatus["over"] = 1] = "over";
})(InfectionEvolutionStatus || (InfectionEvolutionStatus = {}));
